import { PageTitle } from "Components/Titles";
import { ReadUnitPoolCorrection } from "Features/UnitPoolCorrection";
import { Container } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

function ViewUnitPoolCorrection () {

    const { t } = useTranslation();

    return (
        <Container className="page">

            <PageTitle title={t("pages.unitPoolCorrectionDetail")} />
            <ReadUnitPoolCorrection />

        </Container>
    );
}

export default ViewUnitPoolCorrection;